import React from "react";
import emailjs from '@emailjs/browser';
import Typography from '@mui/material/Typography';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './ContactForm.scss';

const ContactForm = () => {

    const serviceId=process.env.REACT_APP_SERVICE_ID;
    const templateId=process.env.REACT_APP_TEMPLATE_ID;

    const [ formData, setFormData ] = React.useState({
        name:'',
        email:'',
        subject:'',
        message:''
    });

    React.useEffect(() => {
        emailjs.init(process.env.REACT_APP_USER_ID);
    }, []);

    const changeData = (e) => {

        const { name, value } = e.target;

        setFormData((prevState) => (
            {
                ...prevState,
                [name]: value,
            }
        ));
    }

    const submitForm = async () => {

        if (formData.name==='' || formData.email==='' || formData.message==='') {
            return;
        }

        const templateParams = {
            from_name: formData.name,
            reply_to: formData.email,
            subject: formData.subject,
            message: formData.message
        };

        const myPromise = new Promise((resolve, reject) => emailjs.send(serviceId, templateId, templateParams)
                .then((result) => {
                    resolve(result.text);
                }, (error) => {
                    reject(error.text);
                })
            );

        toast.promise(myPromise, {
            pending: 'Sending Message',
            success: 'Message Sent!',
            error: 'Error sending Message!'
        }, {
            position: toast.POSITION.BOTTOM_LEFT,
            theme: "dark"
        });

        setFormData({
            name:'',
            email:'',
            subject:'',
            message:''
        });
    }

    return (
        <div className="contact-form">

            <ToastContainer />

            <Typography variant="h6" gutterBottom component="div" className="say-hi">
                Say Hi to Me.
            </Typography>

            <div className="form-row">
                <div className="col-sm-5">
                    <input 
                        type="text" 
                        className="form-control" 
                        placeholder="Name" 
                        name="name"
                        value={formData.name}
                        onChange={changeData}
                    />
                </div>

                <div className="col-sm-7">
                    <input 
                        type="email" 
                        className="form-control"
                        placeholder="Email" 
                        name="email"
                        value={formData.email}
                        onChange={changeData}
                    />
                </div>
            </div>

            <input 
                type="text" 
                className="form-control" 
                placeholder="Subject" 
                name="subject"
                value={formData.subject}
                onChange={changeData}
             />

            <textarea 
                className="form-control" 
                rows="5" 
                placeholder="Message"
                name="message"
                value={formData.message}
                onChange={changeData}
            ></textarea>

            <button  onClick={submitForm} className="submit-button">
                Send Message
            </button>
        </div>
    );
}

export default ContactForm;